import { normalizeCollection } from './normalizeCollection'

// `stat = false` to blok wyłączony w panelu — nie renderujemy go nigdzie na froncie.
export const normalizeBlocks = (blocks) =>
  normalizeCollection(blocks).filter(
    (block) => block && typeof block === 'object' && block.type?.value && block.stat !== false,
  )
